module.exports = __webpack_public_path__ + "static/media/8_17.af9ed4cf.png";